<template>
  <v-app v-if="!loading">
    <Header />
    <v-main v-if="event">
      <v-container class="px-4 py-0 fill-height" fluid>
        <v-row class="fill-height">
          <v-col>
            <transition name="fade">
              <router-view> </router-view>
            </transition>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <v-footer app color="primary" class="white--text">
      <span></span>
      <v-spacer></v-spacer>
      <span
        >{{ $appTitle }} {{ $appVersion }} &copy;
        {{ new Date().getFullYear() }}</span
      >
    </v-footer>
  </v-app>
</template>
<script>
import Header from "@/components/Admin/Header/Header.vue";
import { mapState } from "vuex";
export default {
  components: {
    Header
  },
  data: () => {
    return {
      loading: true
    };
  },

  computed: {
    ...mapState({
      event: (state) => state.events.event
    })
  },

  sockets: {
    onlineUsers(data) {
      this.$store.commit("SET_ONLINE_USERS", data);
    }
  },

  mounted() {
    this.loading = true;
    this.$store.dispatch("loadEvents");
    //this.$VuetifySwitchTheme("teal");
    //this.$socket.client.emit('JOIN_MANAGERS');
    this.$socket.client.open();
    this.$socket.client.on("connect", () => {
      this.$socket.client.emit("JOIN_MANAGERS", this.$store.state.manager);
      console.log("Admin Connecting");
    });
    this.$socket.client.on("reconnect", () => {
      console.log("Admin Reconnecting");
    });
    this.$socket.client.on("disconnect", () => {
      console.log("Admin Disconnecting");
    });
    this.loading = false;
  }
};
</script>
<style>
@media (min-width: 1904px) {
  .container {
    max-width: 1264px;
  }
}
.v-navigation-drawer {
  z-index: 999 !important;
}
</style>
